// common/components/storeSelectorButton/StoreSelectorButton.tsx
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdStore } from "react-icons/md";
import {
  selectForceStores,
  selectStoreList,
  setForceStores,
} from "../../../store/slices/storeListSlice";
import { selectCurrentCluster } from "../../../store/slices/currentClusterSlice";
import styles from "./StoreSelectorButton.module.scss";

export const StoreSelectorButton: React.FC = () => {
  const dispatch = useDispatch();
  const currentCluster = useSelector(selectCurrentCluster);
  const forceStores = useSelector(selectForceStores);
  const storeList = useSelector(selectStoreList);

  const forceStoreEnabled = currentCluster?.forceStore ?? false;
  const isVisible = forceStoreEnabled && forceStores.length > 0;

  if (!forceStoreEnabled) return null;

  const selectedStoreId = forceStores[0];
  const selectedStore = storeList.find((s) => s.id === selectedStoreId);
  const displayName = selectedStore?.name || "Выбрать точку";

  const handleClick = () => {
    dispatch(setForceStores([]));
  };

  return (
    <button className={`${styles.button} ${isVisible ? styles.visible : ""}`} onClick={handleClick}>
      <MdStore size={18} />
      <span className={styles.label}>{displayName}</span>
    </button>
  );
};